<div class="container">
  <div class="row">
    <div class="col-sm-12 col-md-4">
      <div class="setting-menu">
        <div class="personal-info">
          <div class="name-image">
            <div class="avatar-wrapper">
              <img [src]="profileImageDisplay" alt="" class="avatar-img" (error)="onImageError($event)" />
              <button
                type="button"
                class="avatar-change-btn"
                [disabled]="uploadingAvatar"
                (click)="triggerAvatarInput()"
                [title]="'changeAvatar' | translate"
              >
                <i class="fa fa-camera" *ngIf="!uploadingAvatar"></i>
                <i class="fa fa-spinner fa-spin" *ngIf="uploadingAvatar"></i>
              </button>
              <input
                #fileInput
                type="file"
                accept="image/jpeg,image/png,image/gif,image/webp"
                class="d-none"
                (change)="onAvatarFileSelected($event)"
              />
            </div>
            <h5 class="mx-3 fw-bold">{{accoutDto?.name}}</h5>
          </div>
          <div class="email">
            <h6 class="fw-bold">{{ "email" | translate }}:</h6>
            <p>{{accoutDto?.email}}</p>
          </div>
          <div class="operations-created-banner" *ngIf="accoutDto?.isCreatedByOperationsTeam">
            <p class="text-muted mb-0 small">{{ 'accountSettings.createdByOperations' | translate }}</p>
          </div>
          <div class="phone">
            <h6 class="fw-bold">{{ "phoneNumber" | translate }}:</h6>
            <p dir="ltr" class="phone-number">+966 {{accoutDto?.phone}}</p>
          </div>
        </div>
        <div class="tabs mt-4">
          <ul>
            <li *ngFor="let tap of visibleTaps">
              <a
                (click)="selectTap(tap.name)"
                [class.active]="selectedTap === tap.name"
              >
                <i class="{{ tap.icon }}"></i>
                <p>
                  {{ tap.name | translate }}
                </p>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-md-8">
      <div class="setting-content">
        <div *ngIf="selectedTap === 'accountInformation'">
          <div class="acc-tap">
            <h3 class="acc-tap-title">{{ "accountInfo" | translate }}</h3>
            <hr class="m-0" />
            <div class="acc-tap-content">
              <div class="info">
                <div class="row">
                  <div class="col-6">
                    <strong>{{ "name" | translate }}</strong>
                    <p>{{accoutDto?.fullName}}</p>
                  </div>
                  <div class="col-6">
                    <strong>{{ "birthDate" | translate }}</strong>
                   <p>{{accoutDto?.birthdate}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="selectedTap === 'companyInformation'">
          <app-client-info [isDetails]="false" [isDisabled]="false"></app-client-info>
        </div>

        <div *ngIf="selectedTap === 'bankAccount'">
          <app-bank-account></app-bank-account>
        </div>

        <div *ngIf="selectedTap === 'changePassword'">
          <app-change-password  [currentEmail]="accoutDto?.email || ''"></app-change-password>
        </div>

        <div *ngIf="selectedTap === 'editEmail'">
          <app-edit-email  [currentEmail]="accoutDto?.email || ''"  [phoneNumber]="accoutDto?.phone || ''"></app-edit-email>
        </div>

        <div *ngIf="selectedTap === 'editPhoneNumber'">
          <app-edit-phone-number [phoneNumber]="accoutDto?.phone || ''"  ></app-edit-phone-number>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="setting-footer">
  {{ "footerText" | translate }}
</div>
